import { Slot } from '../interfaces/slot-response.interface';

export class SaveSlotDetail {
    static readonly type = '[Slot Details] Save slot details';
    constructor(public slot: Slot) { }
}
